/* istanbul ignore file */
import RFKApiAdapter from './api/apiAdapter.js';
import DataProviderProcessor from './api/dataProvider/processor.js';
import { getUserId } from './api/siteInfo.js';
/**
 * Action layer
 */
/**
 * SDK request and event tracker
 */
export { default as DataProvider } from './api/dataProvider/index.js';
export { default as Request } from './api/SearchRequest.js';
export { default as OCRequest } from './api/OCSearchRequest.js';
export { default as SearchResultsWidgetRequest } from './api/SearchResultsWidgetSearchRequest.js';
export * from './api/siteInfo.js';
export * from './api/types/SearchRequest.js';
export * as OCRequestTypes from './api/types/OCSearchRequest.js';
export { default as WidgetRequest } from './api/WidgetSearchRequest.js';
export { setUserId, getServiceConfig, setTrackConsent } from './config.js';
export { default as Context } from './context/index.js';
export { default as OCContext } from './ordercloud/index.js';
export * as defaultRequests from './defaults/index.js';
export { default as PageWidgetsRequest } from './api/PageWidgetsRequest.js';
export * from './events/funnelEvents.js';
export * from './events/previewSearchEvents.js';
export * from './events/recommendationEvents.js';
export * from './events/searchResultsEvents.js';
export * from './events/widgetEvents.js';
export { FacetTypeFilteringOptions } from './facet/type/index.model.js';
export * from './filter/index.js';
export { build } from './model/index.js';
export * from './setup.js';
export * from './models/index.js';
export { default as EventContext } from './events/eventContext.js';
export { emptyObject } from '@sitecore-search/common';
export { DataProviderProcessor };
export const clearCache = () => {
    RFKApiAdapter.clearCache();
};
export const getRfkUserId = () => {
    const { user_id: userId, uuid } = getUserId();
    return userId || uuid;
};
/**
 * Extracts the domain from a given key.
 *
 * @param customerKey - The customer key to extract the domain from.
 * @returns The extracted domain.
 */
export const extractDomain = (customerKey) => {
    const keyParts = customerKey.split('-');
    return (keyParts.length === 2 && keyParts[1]) || '';
};
